import { inject, Injectable } from '@angular/core';
import { CalAngularService } from '@cvx/cal-angular';
import { Router } from '@angular/router';
import { LoggedInUserService } from './logged-in-user-service';

// sessionStorage is scoped to the tab, so it survives the full-page redirect
// round trip to Azure AD and back, but is naturally isolated per tab (e.g. a
// worksheet opened in a new tab won't clobber the main tab's saved URL).
// Also captured as early as possible in main.ts, before Angular/CAL bootstrap
// can trigger a sign-in redirect.
export const RETURN_URL_STORAGE_KEY = 'fluidsys.postLoginReturnUrl';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private authService: CalAngularService = inject(CalAngularService);
  private loggedInUserService: LoggedInUserService = inject(LoggedInUserService);
  private router: Router = inject(Router);

  login() {
    // isUserSignedIn() returns an Observable, so it must be subscribed to -
    // checking its truthiness directly always evaluates true.
    this.authService.isUserSignedIn().subscribe((isSignedIn) => {
      if (isSignedIn) {
        this.loggedInUserService.setCurrentUser(this.authService.cvxClaimsPrincipal);
        this.restoreReturnUrl();
      }
    });
  }

  private restoreReturnUrl(): void {
    const path = sessionStorage.getItem(RETURN_URL_STORAGE_KEY);
    if (!path) return;

    sessionStorage.removeItem(RETURN_URL_STORAGE_KEY);
    if (this.router.url !== path) {
      this.router.navigateByUrl(path);
    }
  }
}
